import type { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { getPortfolioGroupInstrumentDropdown } from "src/Requests/portfolioGroups";

export const getPortfolioGroupInstrumentOptions = (): Promise<DropdownItem[]> =>
  getPortfolioGroupInstrumentDropdown();

export const getPortfolioGroupNonOptionInstrumentOptions = (): Promise<DropdownItem[]> =>
  getPortfolioGroupInstrumentDropdown(false);
